// extracted by mini-css-extract-plugin
module.exports = {"content":"Login_content__oS9fY","link":"Login_link__Rg6V1"};